/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const PimDocumentV1TypeEnum = {
    InternalHw: 'internal-hw',
    InternalLv: 'internal-lv',
    InternalBp: 'internal-bp',
    ExternalLv: 'external-lv',
    ExternalBp: 'external-bp'
};
